import { render, staticRenderFns } from "./bdproduct1.vue?vue&type=template&id=6e9a4f43&scoped=true"
import script from "./bdproduct1.vue?vue&type=script&lang=js"
export * from "./bdproduct1.vue?vue&type=script&lang=js"
import style0 from "./bdproduct1.vue?vue&type=style&index=0&id=6e9a4f43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9a4f43",
  null
  
)

export default component.exports